module.exports = __webpack_public_path__ + "img/wblog-1.ee032c26.png";